module.exports = __webpack_public_path__ + "img/KUCE-09.0b96e6dc.png";